import React from "react";
import ReactDOM from "react-dom/client";
import { UserWrapper } from "./context";
import App from "./App.jsx";
import "./index.scss";
import "react-toastify/dist/ReactToastify.css";

import { MODE } from "./config/index.js";
import { UserProvider } from "./context/userContext.js";

if (MODE !== "production") {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <UserProvider>
      <UserWrapper>
        <App />
      </UserWrapper>
    </UserProvider>
  );
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <UserProvider>
        <UserWrapper>
          <App />
        </UserWrapper>
      </UserProvider>
    </React.StrictMode>
  );
}
